import { render, staticRenderFns } from "./ListGroupTypeBenefits.vue?vue&type=template&id=332d3a2b&"
import script from "./ListGroupTypeBenefits.vue?vue&type=script&lang=js&"
export * from "./ListGroupTypeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports